import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=0036ab77&scoped=true&"
import script from "./PaymentStatus.vue?vue&type=script&lang=js&"
export * from "./PaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036ab77",
  null
  
)

export default component.exports